export const AUTHORIZATION = 'X-AUTH-TOKEN'
export const API_SERVER = process.env.NODE_ENV === 'production' ? 'https://mining-api.monterra.tech' : 'http://localhost:8989'
export const BASE_URL = '/web-api/v1/'



// WEBPACK FOOTER //
// ./src/constants/constants.js